import { useState } from "react"
import { Link } from "react-router-dom"
import {Droplets, Menu, X, Calculator, Activity, BookOpen, History} from 'lucide-react'

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false)

  const links = [
    { label: "Calculator", href: "#calculator" },
    { label: "How It Works", href: "#education" },
    { label: "TDEE & Fat", href: "#tdee-fat" },
    { label: "TDEE vs BMI", href: "#tdee-vs-bmi" },
    { label: "Water Intake", href: "#water" },
    { label: "FAQ", href: "#faq" },
  ]

  const pageLinks = [
    { label: "TDEE Calculator", to: "/tdee-bmr-calculator", icon: Activity },
    { label: "TDEE vs BMI Blog", to: "/blog/tdee-vs-bmi-fat-intake", icon: BookOpen },
    { label: "History", to: "/history", icon: History },
  ]

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-100 shadow-[0_1px_0_rgba(15,23,42,0.04),0_8px_24px_-8px_rgba(15,23,42,0.06)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2.5 group">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-md shadow-emerald-500/20 group-hover:shadow-lg group-hover:shadow-emerald-500/30 transition-all duration-300 group-hover:-translate-y-0.5">
              <Calculator className="w-5 h-5 text-white" />
            </div>
            <span className="font-bold text-slate-800 text-lg tracking-tight" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              Fat<span className="text-emerald-600">Calc</span>
            </span>
          </a>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-0.5">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="relative px-3.5 py-2 text-sm font-medium text-slate-600 hover:text-emerald-700 rounded-lg hover:bg-emerald-50/80 transition-all duration-200"
              >
                {link.label}
              </a>
            ))}
            <div className="w-px h-5 bg-slate-200 mx-1.5" />
            {pageLinks.map((pl) => {
              const Icon = pl.icon
              return (
                <Link
                  key={pl.to}
                  to={pl.to}
                  className="px-3 py-2 text-sm font-medium text-emerald-600 hover:text-emerald-700 rounded-lg hover:bg-emerald-50/80 transition-all duration-200 flex items-center gap-1.5"
                >
                  <Icon className="w-3.5 h-3.5" />
                  {pl.label}
                </Link>
              )
            })}
            <a
              href="#water"
              className="ml-2.5 flex items-center gap-1.5 px-4 py-2 bg-gradient-to-br from-emerald-500 to-emerald-600 text-white text-sm font-semibold rounded-lg hover:from-emerald-600 hover:to-emerald-700 transition-all duration-200 shadow-md shadow-emerald-500/25 hover:shadow-lg hover:shadow-emerald-500/30 hover:-translate-y-0.5"
            >
              <Droplets className="w-4 h-4" />
              Water Tool
            </a>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 active:scale-95 transition-all duration-150"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 animate-slide-down shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="block px-4 py-2.5 text-sm font-medium text-slate-600 hover:text-emerald-700 rounded-lg hover:bg-emerald-50/80 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <div className="border-t border-slate-100 pt-2 mt-1">
              {pageLinks.map((pl) => {
                const Icon = pl.icon
                return (
                  <Link
                    key={pl.to}
                    to={pl.to}
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-emerald-600 hover:bg-emerald-50/80 rounded-lg transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                    {pl.label}
                  </Link>
                )
              })}
            </div>
            <a
              href="#water"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-1.5 px-4 py-2.5 bg-gradient-to-br from-emerald-500 to-emerald-600 text-white text-sm font-semibold rounded-lg mt-2 shadow-md shadow-emerald-500/20"
            >
              <Droplets className="w-4 h-4" />
              Water Intake Tool
            </a>
          </div>
        </div>
      )}
    </nav>
  )
}
